<template>
  <div class="service detail wrap">
    <div class="text-bg ddh">
      <div class="text-wrap">
        <p>{{ $t('solution.detail.nsddh.lineText.01') }}</p>
        <p>{{ $t('solution.detail.nsddh.lineText.02') }}</p>
        <p>{{ $t('solution.detail.nsddh.lineText.03') }}</p>
      </div>
    </div>
    <HalfPageLayout class="ddh title">
      <template #half-left>
        <div class="img ddh"></div>
      </template>
      <template #half-right>
        <div class="inner-contents" style="margin-top: -5vh">
          <div class="contents-title">
            <h3 style="line-height: 1.1">
              {{ $t('solution.title.nsddh') }}
            </h3>
            <h6>NS Dynamic Data Hub</h6>
            <h4>{{ $t('solution.detail.nsddh.subTitle') }}</h4>
          </div>
          <div class="contents-list flex mb-50">
            <h5 class="circle">{{ $t('solution.detail.nsddh.circle.detect') }}</h5>
            <h5 class="circle">{{ $t('solution.detail.nsddh.circle.monitoring') }}</h5>
            <h5 class="circle">{{ $t('solution.detail.nsddh.circle.operator') }}</h5>
          </div>
          <h5>{{ $t('solution.detail.nsddh.desc') }}</h5>
        </div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="ddh summary">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('solution.detail.nsddh.firstPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:detective-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.nsddh.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('solution.detail.nsddh.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="700">
              <Icon icon="ph:monitor-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.nsddh.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('solution.detail.nsddh.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="900">
              <Icon icon="ph:sliders-horizontal-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.nsddh.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('solution.detail.nsddh.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-01"></div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="ddh summary">
      <template #half-left>
        <div class="img visual-02"></div>
      </template>
      <template #half-right>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('solution.detail.nsddh.secondPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:password-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.nsddh.secondPage.contents.01.title') }}</dt>
                <dd>{{ $t('solution.detail.nsddh.secondPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="700">
              <Icon icon="ph:arrows-clockwise-thin"></Icon>
              <dl>
                <dt>{{ $t('solution.detail.nsddh.secondPage.contents.02.title') }}</dt>
                <dd>{{ $t('solution.detail.nsddh.secondPage.contents.02.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="ddh summary bg-light">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('consulting.detail.member.firstPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:user-circle-plus-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.member.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('consulting.detail.member.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="700">
              <Icon icon="ph:tree-structure-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.member.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('consulting.detail.member.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="900">
              <Icon icon="ph:arrows-counter-clockwise-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.member.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('consulting.detail.member.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-03"></div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="ddh summary">
      <template #half-left>
        <div class="img visual-04"></div>
      </template>
      <template #half-right>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('consulting.detail.member.secondPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:user-gear-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.member.secondPage.contents.01.title') }}</dt>
                <dd>{{ $t('consulting.detail.member.secondPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="700">
              <Icon icon="ph:clock-clockwise-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.member.secondPage.contents.02.title') }}</dt>
                <dd>{{ $t('consulting.detail.member.secondPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="900">
              <Icon icon="ph:magnifying-glass-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.member.secondPage.contents.03.title') }}</dt>
                <dd>{{ $t('consulting.detail.member.secondPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </HalfPageLayout>
    <section class="section ddh benefit bg-dark">
      <h2 class="hl section-title">{{ $t('solution.detail.nsddh.benefit.title') }}</h2>
      <div class="section-contents">
        <div class="inner-contents">
          <div class="contents-list">
            <dl data-aos="zoom-in">
              <div class="img ddh"></div>
              <dt>{{ $t('solution.detail.nsddh.benefit.contents.01.title') }}</dt>
              <dd>{{ $t('solution.detail.nsddh.benefit.contents.01.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img ddh"></div>
              <dt>{{ $t('solution.detail.nsddh.benefit.contents.02.title') }}</dt>
              <dd>{{ $t('solution.detail.nsddh.benefit.contents.02.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img ddh"></div>
              <dt>{{ $t('solution.detail.nsddh.benefit.contents.03.title') }}</dt>
              <dd>{{ $t('solution.detail.nsddh.benefit.contents.03.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img ddh"></div>
              <dt>{{ $t('solution.detail.nsddh.benefit.contents.04.title') }}</dt>
              <dd>{{ $t('solution.detail.nsddh.benefit.contents.04.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img ddh"></div>
              <dt>{{ $t('solution.detail.nsddh.benefit.contents.05.title') }}</dt>
              <dd>{{ $t('solution.detail.nsddh.benefit.contents.05.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img ddh"></div>
              <dt>{{ $t('solution.detail.nsddh.benefit.contents.06.title') }}</dt>
              <dd>{{ $t('solution.detail.nsddh.benefit.contents.06.desc') }}</dd>
            </dl>
          </div>
        </div>
        <router-link to="/contact" class="button big line">
          {{ $t('service.detail.contact') }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import HalfPageLayout from '@/components/HalfPageLayout'
import { Icon } from '@iconify/vue'
import SvgGear from '@/components/SvgGear'

export default {
  name: 'SolutionDetailNsddh',
  components: { HalfPageLayout, Icon, SvgGear }
}
</script>

<style scoped>
</style>
